<agpr-take-over-panel
    [id]="id"
    [header]="'Discover.distribution.editPersonalization.header' | localize: { name : currentEntity?.entityType === entityType.CONTACT 
        ? $any(currentEntity)?.firstName + ' ' + $any(currentEntity)?.lastName : currentEntity?.name }"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close()"
>
    <div
        class="editPersonalization"
        [agprLoading]="loading"
    >
        <div class="editPersonalization-center">
            <agpr-tabs
                class="editPersonalization-tabs"
                [variableHeaderWidth]="true"
                [selectedTabIndex]="selectedTab"
                (selectedTabIndexChange)="tabChange($event)"
            >
                <agpr-tab
                    #personalizationTab
                    [id]="id + '_personalization_tab'"
                    heading="Discover.distribution.editPersonalization.tab.personalization"
                ></agpr-tab>
                <agpr-tab
                    #compositionPreviewTab
                    [id]="id + '_compositionPreview_tab'"
                    heading="Discover.distribution.editPersonalization.tab.compositionPreview"
                ></agpr-tab>
            </agpr-tabs>
            @if (personalizationTab?.selected) {
                <div class="headerRow">
                    <span class="header-firstCol">
                        {{ 'Discover.distribution.editPersonalization.tab.personalization' | localize }}
                    </span>
                    <div class="headerRow-group">
                        <span> {{ 'Discover.distribution.system' | localize }} </span>
                        <agpr-button
                            class="header-edit"
                            [id]="id + '_toolbar_editButton'"
                            [style]="buttonType.icon"
                            icon="fa-regular fa-duotone fa-pen"
                            tooltipPosition="top"
                            tooltip="Discover.distribution.personalization.edit.tooltip"
                            (click)="editFallback()"
                        ></agpr-button>
                    </div>
                    <span> {{ 'Discover.distribution.custom' | localize }} </span>
                    <agpr-button
                        *ngIf="unsavedPeronsalizations > 0"
                        class="header-save"
                        [id]="id + '_saveButton'"
                        [style]="buttonType.secondary"
                        icon="fa-regular fa-duotone fa-floppy-disk"
                        tooltipPosition="top"
                        tooltip="Discover.distribution.personalization.save.tooltip"
                        (click)="saveAll()"
                    >
                        <span> {{ unsavedPeronsalizations }} </span>
                    </agpr-button>
                </div>
                <agpr-scroll-panel class="list">
                    @for (personalization of personalizations; track personalization; let index = $index) {
                        <li
                            *ngIf="contactHeadingIndex === index"
                            class="list-sectionHeader"
                        >
                            <span>
                                {{ 'Discover.distribution.editPersonalization.contactDetails' | localize }}
                            </span>
                        </li>
                        <li
                            *ngIf="distHeadingIndex === index"
                            class="list-sectionHeader"
                        >
                            <span>
                                {{ 'Discover.distribution.editPersonalization.distributionDetails' | localize }}
                            </span>
                        </li>
                        <li
                            class="listRow"
                            [ngClass]="{'listRow-top': personalization.tagType === personalizationTagEnum.INTRO ||
                                personalization.tagType === personalizationTagEnum.OUTRO
                            }"
                        >
                            <div class="listRow-group">
                                <span class="listRow-firstCol">
                                    {{ ('Discover.personalizationTag.' + personalization.tagType) | localize }}
                                </span>
                            </div>
                            <div class="listRow-section">
                                <div class="listRow-group">
                                    <agpr-radio
                                        [(ngModel)]="personalization.selectedSource"
                                        (ngModelChange)="updateSelection(personalization)"
                                        [value]="personalizationSourceTypeEnum.SYSTEM"
                                    ></agpr-radio>
                                    <div class="listRowCol">
                                        @if (personalization.system.length > 0) {
                                            <span class="listRow-group-text">
                                                {{ personalization.system }}
                                            </span>
                                        } @else if (personalization.fallback.length > 0) {
                                            <span class="listRow-group-text">
                                                {{ personalization.fallback }}
                                            </span>
                                        } @else {
                                            <span class="list-blank">
                                                {{ 'Discover.distribution.editPersonalization.blankField' | localize }}
                                            </span>
                                        }
                                        @if (
                                                personalization.system?.length >= MAX_TEXT_COUNT &&
                                                (personalization.tagType === personalizationTagEnum.INTRO ||
                                                personalization.tagType === personalizationTagEnum.OUTRO)
                                            ) {
                            
                                            <agpr-button
                                                class="listRowCol-button"
                                                [style]="buttonType.link"
                                                label="Discover.distribution.editPersonalization.viewFullText"
                                                (click)="openPreview(personalization.system, personalization.tagType)"
                                            ></agpr-button>
                                        }
                                    </div>
                                </div>

                                @if (
                                    personalization.system.length === 0 &&
                                    personalization.selectedSource === personalizationSourceTypeEnum.SYSTEM
                                ) {
                                    <span
                                        *ngIf="personalization.fallback.length > 0"
                                        class="fa solid fa-duotone fa-circle-exclamation list--warning"
                                        agprTooltip="Discover.distribution.editPersonalization.warning"
                                    ></span>
                                    <span
                                        *ngIf="personalization.fallback.length === 0"
                                        class="fa solid fa-duotone fa-circle-minus list--error"
                                        agprTooltip="Discover.distribution.editPersonalization.error"
                                    ></span>
                                }
                            </div>
                            <div class="listRow-group">
                                <agpr-radio
                                    [(ngModel)]="personalization.selectedSource"
                                    (ngModelChange)="updateSelection(personalization)"
                                    [value]="personalizationSourceTypeEnum.CUSTOM"
                                ></agpr-radio>
                                @if (
                                    personalization.tagType === personalizationTagEnum.INTRO ||
                                    personalization.tagType === personalizationTagEnum.OUTRO
                                ) {
                                    <div class="listRowCol">
                                        @if (personalization.custom.length > 0) {
                                            <div class="listRow-group-text">
                                                <agpr-shadow-dom-container
                                                    [customHtml]="personalization.custom"
                                                ></agpr-shadow-dom-container>
                                            </div>
                                        } @else {
                                            <span class="list-blank">
                                                @if (personalization.tagType === personalizationTagEnum.INTRO) {
                                                    {{ 'Discover.distribution.editPersonalization.noIntro' | localize }}
                                                } @else {
                                                    {{ 'Discover.distribution.editPersonalization.noOutro' | localize }}
                                                }
                                            </span>
                                        }
                                        @if (personalization.custom?.length >= MAX_TEXT_COUNT) {
                                            <agpr-button
                                                class="listRowCol-button"
                                                [style]="buttonType.link"
                                                label="Discover.distribution.editPersonalization.viewFullText"
                                                (click)="openPreview(personalization.custom, personalization.tagType)"
                                            ></agpr-button>
                                        }
                                    </div>
                                } @else {
                                    <agpr-text-input
                                        [placeholder]="'Discover.distribution.personalization.custom.tooltip' | localize : { 
                                            personalizationType: (('Discover.personalizationTag.' + personalization.tagType) | localize)
                                        }"
                                        [(ngModel)]="personalization.custom"
                                        (blur)="customChange(personalization)"
                                        (focus)="switchToCustom(personalization)"
                                    ></agpr-text-input>
                                }
                                <div class="list-endFloat">
                                    @if (personalization.custom.length === 0 &&
                                        personalization.selectedSource === personalizationSourceTypeEnum.CUSTOM) {
                                        <span
                                            class="fa solid fa-duotone fa-circle-minus list--error"
                                            agprTooltip="Discover.distribution.editPersonalization.error"
                                        ></span>
                                    }
                                </div>
                            </div>
                            <div class="listRow-endCol">
                                @if (personalization.custom !== personalization.profile &&
                                    (
                                        currentEntity.entityType === entityType.CONTACT && allowedContactProfileSaveTags.includes(personalization.tagType) ||
                                        currentEntity.entityType === entityType.OUTLET && allowedOutletProfileSaveTags.includes(personalization.tagType)
                                    )
                                ) {
                                    <agpr-button
                                        class="listRow--save"
                                        [id]="id + '_saveButton'"
                                        [style]="buttonType.icon"
                                        icon="fa-regular fa-duotone fa-floppy-disk"
                                        tooltipPosition="top"
                                        tooltip="Discover.distribution.personalization.save.tooltip"
                                        (click)="saveToProfile(personalization)"
                                    ></agpr-button>
                                }

                                @if (
                                    personalization.tagType === personalizationTagEnum.INTRO ||
                                    personalization.tagType === personalizationTagEnum.OUTRO
                                ) {
                                    <agpr-button
                                        [id]="id + '_aiButton'"
                                        class="listRow-aiButton"
                                        [style]="buttonType.icon"
                                        icon="fa-regular fa-duotone fa-pen"
                                        tooltipPosition="top"
                                        [tooltip]="personalization.tagType === personalizationTagEnum.INTRO ? 
                                            'Discover.distribution.editPersonalizationIntro.tooltip': 'Discover.distribution.editPersonalizationOutro.tooltip'"
                                        (click)="aiRefinement(personalization, currentEntity)"
                                    ></agpr-button>
                                }
                            </div>
                        </li>
                    }
                </agpr-scroll-panel>
            } @else if (compositionPreviewTab?.selected) {
                <agpr-button
                    [id]="id + '_composition_hideButton'"
                    class="composition-hideButton"
                    [style]="buttonType.link"
                    [label]="highlightTags ? 'Discover.distribution.editPersonalization.hidePersonalization' : 
                        'Discover.distribution.editPersonalization.showPersonalization'"
                    (click)="toggleHighlights()"
                ></agpr-button>
                <div class="composition-header">
                    <div class="composition-headerRow composition-headerBold" >
                        <span> {{ 'Discover.distribution.editPersonalization.subject' | localize }}: </span>
                        <span> {{ 'Discover.distribution.editPersonalization.previewText' | localize }}: </span>
                    </div>
                    <div class="composition-headerRow">
                        <div [innerHTML]="highlightTags ? subjectHighlight : subject"></div>
                        <div [innerHTML]="highlightTags ? previewHighlight : preview"></div>
                    </div>
                </div>
                <agpr-scroll-panel>
                    <agpr-shadow-dom-container
                        [customHtml]="highlightTags ? bodyHighlight : body"
                    ></agpr-shadow-dom-container>
                </agpr-scroll-panel>
            }
        </div>
        <aside
            class="sidebar"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-rhp-contexts
                [id]="'recipientViewer_rhp'"
                [overlayContainer]="overlayContainer"
                [disableContentToggle]="true"
                [showFooter]="false"
            ></agpr-rhp-contexts>
        </aside>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_previousButton'"
            (click)="previous()"
            [disabled]="pageCriteria.page === 1 && currentIndex === 0"
            label="Discover.distribution.editPersonalization.previous"
            [style]="buttonType.primaryB"
        ></agpr-button>
        <agpr-button
            [id]="id + '_nextButton'"
            (click)="next()"
            [disabled]="pageCriteria.page === personalizationService.totalNumberOfPages && currentIndex === recipients.length-1"
            label="Discover.distribution.editPersonalization.next"
            [style]="buttonType.primaryB"
        ></agpr-button>
        <agpr-button
            [id]="id + '_doneButton'"
            (click)="close()"
            label="Discover.distribution.editPersonalization.close"
            [style]="buttonType.primary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
